module.exports = __webpack_public_path__ + "img/icn_delete.d4617c51.svg";